import {CreateBranchDialogReposServerQuery} from '@github-ui/server-persisted-queries'
import type {CreateBranchDialogReposServerQueryQuery} from '@github-ui/server-persisted-queries/types/CreateBranchDialogReposServerQuery'
import {reactFetchJSON} from '@github-ui/verified-fetch'

export function createBranchDialogReposQueryKey(owner: string, repo: string) {
  return ['issue-viewer', 'create-branch-dialog-repos', {owner, repo}] as const
}

export async function fetchCreateBranchDialogRepos(
  owner: string,
  repo: string,
  signal?: AbortSignal,
): Promise<CreateBranchDialogReposServerQueryQuery> {
  const query = new URLSearchParams({queryId: CreateBranchDialogReposServerQuery})
  const response = await reactFetchJSON(`/${owner}/${repo}/create_branch_dialog_repos.json?${query.toString()}`, {
    signal,
  })

  if (!response.ok) throw new Error(`Create branch dialog repositories fetch failed (${response.status})`)

  const json = (await response.json()) as {data?: CreateBranchDialogReposServerQueryQuery}
  // Relay rendered usable partial responses, so preserve that behavior when GraphQL also returns errors.
  if (!json.data) throw new Error('Create branch dialog repositories query returned no data')

  return json.data
}
